<template>
    <chooser
        title='בחירת שאלות לשאלון הקבלה'
        tooltipIntent='להוסיף לשאלון הקבלה'
        tooltipAction='{click} "המשך" כדי לשמור'
    >
        <template #sidebar>
            <submit-button
                text='המשך'
                :submitCallback='submit'
                :immediateLoading='true'
            />
        </template>
    </chooser>
</template>

<script lang='ts'>
import { defineComponent } from '@vue/runtime-core';
import { getSelected } from '../Chooser/helpers';

export default defineComponent({
    methods: {
        submit(){
            if(getSelected())
                this.$router.push(`${this.$store.state.chooser!.previousRoute.path}`);
        }
    }
});
</script>